interface FirebaseTimestamp {
    seconds: number;
    nanoseconds: number;
}

/**
 * Converts Firebase timestamp to human-readable format (e.g., "5 minutes", "2 hours", "3 days")
 */
export const getTimeInWordFormat = (timeInSeconds: FirebaseTimestamp): string => {
    const time = new Date(timeInSeconds.seconds * 1000 + timeInSeconds.nanoseconds / 1e6);
    const currentTime = new Date();
    const timeDifference = currentTime.getTime() - time.getTime();
    const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    const hoursDifference = Math.floor(
        (timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
    );
    const minutesDifference = Math.floor(
        (timeDifference % (1000 * 60 * 60)) / (1000 * 60),
    );

    let timeInWordFormat = '';
    if (daysDifference >= 1) {
        timeInWordFormat = `${daysDifference} ${daysDifference === 1 ? 'day' : 'days'}`;
    } else if (hoursDifference >= 1) {
        timeInWordFormat = `${hoursDifference} ${hoursDifference === 1 ? 'hour' : 'hours'}`;
    } else {
        timeInWordFormat = `${minutesDifference} ${minutesDifference === 1 ? 'minute' : 'minutes'}`;
    }

    return timeInWordFormat;
};
